class r {
  static getCommonErrorMessage(s) {
    return [s("sign-in.common-error-message")];
  }
  static getInvalidPasswordMessage(s) {
    return s("sign-in.invalid-password-message");
  }
  static getInvalidEmailMessage(s) {
    return s("sign-in.invalid-email-message");
  }
  static getResettingPasswordSuccessMessage(s, e) {
    return [
      e("sign-in.reset-password-success-first-message", { email: s }),
      e("sign-in.reset-password-success-second-message")
    ];
  }
  static getErrorAlertTitle(s) {
    return s("sign-in.error-alert-title");
  }
  static getSuccessAlertTitle(s) {
    return s("sign-in.success-alert-title");
  }
}
export {
  r as Messages
};
//# sourceMappingURL=index5.js.map
